import React, { useEffect, useState } from 'react';
import { getMyContracts } from '../../services/contracts/contractsService';
import { formatDate } from '../contracts/contractLabels';

// Días antes del vencimiento del pago en que se empieza a avisar
const PAYMENT_NOTICE_DAYS = 5;

const STYLES = {
    danger: 'bg-red-50 border-red-300 text-red-800',
    warning: 'bg-yellow-50 border-yellow-300 text-yellow-900',
    info: 'bg-blue-50 border-blue-300 text-blue-900',
};

// Avisos al cliente sobre la vigencia de sus sensores: prueba, pago próximo o vencido, suspensión
const noticeFor = (c) => {
    const sensor = c.sensorName || c.sensorId;
    if (c.status === 'SUSPENDED') {
        return { level: 'danger', icon: 'block',
            text: `El sensor ${sensor} está suspendido por pago pendiente. Comunícate con nosotros para reactivarlo.` };
    }
    if (c.type === 'TRIAL') {
        return { level: 'info', icon: 'schedule',
            text: `Estás usando el sensor ${sensor} en período de prueba hasta el ${formatDate(c.validUntil)}`
                + (c.daysLeft > 0 ? ` (${c.daysLeft} día${c.daysLeft === 1 ? '' : 's'}).` : '.') };
    }
    if (c.inGrace) {
        return { level: 'warning', icon: 'warning_amber',
            text: `El pago del sensor ${sensor} venció el ${formatDate(c.validUntil)}. El servicio se suspenderá después del ${formatDate(c.graceUntil)}.` };
    }
    if (c.validUntil && c.daysLeft != null && c.daysLeft <= PAYMENT_NOTICE_DAYS) {
        return { level: 'warning', icon: 'event',
            text: `El servicio del sensor ${sensor} está pagado hasta el ${formatDate(c.validUntil)}.` };
    }
    return null;
};

const ContractNotices = () => {
    const [notices, setNotices] = useState([]);

    useEffect(() => {
        getMyContracts()
            .then((contracts) => setNotices(contracts.map(noticeFor).filter(Boolean)))
            // Los avisos son un complemento: si fallan, la vista de sensores sigue igual
            .catch((e) => console.error('Error al consultar la vigencia de los sensores: ', e));
    }, []);

    if (notices.length === 0) return null;

    return (
        <div className="w-full max-w-5xl mx-auto space-y-2 px-4 pt-4">
            {notices.map((n, i) => (
                <div key={i} className={`flex items-start gap-2 p-3 rounded border text-sm shadow ${STYLES[n.level]}`}>
                    <span className="material-icons-outlined text-base">{n.icon}</span>
                    <span>{n.text}</span>
                </div>
            ))}
        </div>
    );
};

export default ContractNotices;
